import api from '../api';

const checkInResults = ['checked_in', 'no_bookings'] as const;

export type CheckInResult = (typeof checkInResults)[number];

function isCheckInResult(value: unknown): value is CheckInResult {
    return checkInResults.includes(value as CheckInResult);
}

/**
 * `null` means the token was rejected.
 */
export async function checkInToken(token: string): Promise<CheckInResult | null> {
    const response = await api.get(`/api/check-in?token=${encodeURIComponent(token)}`);

    if (!response.ok) {
        return null;
    }

    // a backend that does not report a result yet only answers with an empty 204
    if (response.status === 204) {
        return 'checked_in';
    }

    const {result} = (await response.json()) as {result?: string};

    // never claim a successful check-in for a result we do not understand
    return isCheckInResult(result) ? result : 'no_bookings';
}
